// Translate
<template>
  <CalendarSearchBarButton
    id="charterButtonStopover"
    ref="charterButtonStopover"
    :active="active"
    :loading="loading"
    @click="$emit('setActive')"
  >
    <template #icon>
      <fa :icon="icons.faPlaneDeparture" />
    </template>
    <template #label>
      <span data-i18n="charterFilterStopovers">
        {{ $t('charterFilterStopovers') }}
      </span>
    </template>
    <template #content>
      <span data-i18n="dealfinderLabelStopover">
        {{ $t('dealfinderLabelStopover', selectedStopovers) }}
      </span>
    </template>
  </CalendarSearchBarButton>
</template>

<script>
import { faPlaneDeparture } from '@fortawesome/pro-duotone-svg-icons'
import { mapState } from 'pinia'

export default defineNuxtComponent({
  props: {
    active: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['setActive'],

  data () {
    return {
      icons: {
        faPlaneDeparture,
      },
    }
  },

  computed: {
    ...mapState(useCharterPackagesStore, {
      selectedStopovers: 'filterStopover',
    }),
  },
})
</script>
